import EmptyState from "@/components/EmptyState";
import PhotosCarousel from "@/components/profile/PhotosCarousel";
import { ProfileViewDetails } from "@/components/profile/ProfileViewDetails";
import Spinner from "@/components/Spinner";
import { Button } from "@/components/ui/button";
import { useStandaloneMode } from "@/hooks/useStandaloneMode";
import { useTranslation } from "@/hooks/useTranslation";
import { useGetProfileViewSelf } from "@/tanstack-hooks";
import { CloudOffIcon, PencilIcon } from "lucide-react";

import { useNavigate } from "react-router-dom";

export default function SelfProfilePage() {
  const navigate = useNavigate();
  const { data, isLoading, error } = useGetProfileViewSelf();
  const isStandalone = useStandaloneMode();
  const t = useTranslation();

  if (isLoading) {
    return <Spinner />;
  }
  if (error || !data) {
    return (
      <EmptyState
        icon={CloudOffIcon}
        title={t.SELF_PROFILE_VIEW.ERRORS.LOADING}
        message={t.SELF_PROFILE_VIEW.ERRORS.LOADING_DESCRIPTION}
      />
    );
  }

  return (
    <div
      className={`flex flex-col w-full max-w-5xl mx-auto mt-4 ${
        isStandalone ? "pb-14" : "pb-10"
      }`}
    >
      <div className="flex flex-row justify-between items-center mb-4">
        <span className="text-xl ml-1 font-semibold">
          {t.SELF_PROFILE_VIEW.LABELS.YOUR_PROFILE}
        </span>
        <Button
          variant="secondary"
          className="primary"
          onClick={() => navigate("/profile/edit")}
        >
          <PencilIcon className="mr-2 h-4 w-4" />
          {t.SELF_PROFILE_VIEW.LABELS.EDIT_BUTTON}
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 md:gap-4">
        <PhotosCarousel
          userId=""
          userPhotos={data.photos}
          privatePhotoStatus={data.private_photo_status}
        />
        <ProfileViewDetails userId="" profileView={data} isSelfView={true} />
      </div>
    </div>
  );
}
